var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1764_4259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.17549 4.51758C3.46816 4.5175 3.75742 4.58044 4.02361 4.70209C4.28979 4.82375 4.52667 5.00129 4.71814 5.22264L5.36133 5.96514C5.47524 6.09688 5.61618 6.20254 5.77458 6.27494C5.93297 6.34735 6.1051 6.38479 6.27926 6.38473H9V1.37953C9 1.01366 8.85466 0.662768 8.59594 0.404056C8.33723 0.145343 7.98634 1.79202e-07 7.62047 1.79202e-07H1.38023C1.19901 -9.21867e-05 1.01955 0.0355223 0.852095 0.104809C0.684641 0.174095 0.53248 0.275696 0.404304 0.403807C0.276128 0.531917 0.17445 0.684027 0.105078 0.851445C0.0357059 1.01886 -2.35387e-08 1.19831 0 1.37953L0 4.51758H3.17549ZM6.53906 1.20867C6.71811 1.20867 6.89313 1.26177 7.04201 1.36124C7.19088 1.46071 7.30691 1.6021 7.37543 1.76751C7.44394 1.93293 7.46187 2.11495 7.42694 2.29056C7.39201 2.46616 7.30579 2.62747 7.17919 2.75407C7.05258 2.88068 6.89128 2.96689 6.71567 3.00182C6.54007 3.03675 6.35805 3.01883 6.19263 2.95031C6.02721 2.88179 5.88583 2.76576 5.78636 2.61689C5.68688 2.46802 5.63379 2.29299 5.63379 2.11395C5.63379 1.87385 5.72917 1.64359 5.89894 1.47382C6.06871 1.30405 6.29897 1.20867 6.53906 1.20867Z",
    fill: "#D3A515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27855 7.2109C5.98588 7.21097 5.69662 7.14804 5.43044 7.02638C5.16425 6.90472 4.92737 6.72719 4.7359 6.50584L4.09342 5.76352C3.97952 5.63174 3.83859 5.52605 3.68019 5.45361C3.5218 5.38118 3.34966 5.34371 3.17549 5.34375H0V7.62047C0 7.98634 0.145343 8.33723 0.404055 8.59594C0.662768 8.85466 1.01366 9 1.37953 9H7.61977C7.80099 9.00009 7.98045 8.96448 8.14791 8.89519C8.31536 8.8259 8.46752 8.7243 8.5957 8.59619C8.72387 8.46808 8.82555 8.31597 8.89492 8.14855C8.96429 7.98114 9 7.80169 9 7.62047V7.2109H6.27855Z",
    fill: "#D3A515"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1764_4259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.30864f26ed67b9e0d641991279499ee8.svg";
export { ForwardRef as ReactComponent };